// Create a new file called NavigationTabs.jsx
import React from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

const ClientNavtabs = ({ handleMenuClick, options }) => {
  const location = useLocation();
  const currentPath = location.pathname;

  // Map tab labels to their paths
  const tabPaths = {
    "Edit Profile": "/employeedashboard/clients/edit",
    "View Interactions": "/employeedashboard/clients/interactions",
    "Add Interaction": "/employeedashboard/clients/add-interaction",
    "View KYC": "/employeedashboard/clients/kyc",
    "Upload Documents": "/employeedashboard/clients/documents",
    "Add Business Numbers": "/employeedashboard/clients/add-business-numbers",
    "View Business Numbers": "/employeedashboard/clients/business-numbers",
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 3,
        justifyContent: "center",
        flexWrap: "wrap",
        p: 1,
        marginTop: "3px",
      }}
    >
      {options.map((option) => {
        const isActive = currentPath === tabPaths[option.label];
        const isDisabled = option.disabled;
        return (
          <Typography
            key={option.label}
            onClick={!isDisabled ? option.onClick : undefined}
            sx={{
              fontSize: "11px",
              color: isDisabled ? "#9e9e9e" : isActive ? "#002C51" : "black",
              cursor: isDisabled ? "not-allowed" : "pointer",
              fontWeight: isActive ? 700 : 500,
              textDecoration: isActive ? "underline" : "none",
              "&:hover": {
                textDecoration: isDisabled ? "none" : "underline",
              },
            }}
          >
            {option.label}
          </Typography>
        );
      })}
    </Box>
  );
};

export default ClientNavtabs;
